import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmAlert = ({    
    show = false,
    title = "",
    message = "",
    onClose = () => {},
    onConfirm = () => {}
}) => {
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary" onClick={onClose} style={{minWidth:"100px",marginRight:"16px"}}>
                    No
                </Button>
                <Button bsStyle="danger" onClick={onConfirm}>
                    Si
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmAlert;



// WEBPACK FOOTER //
// ./src/components/alert-dialog/ConfirmAlert.js